module.exports = __webpack_public_path__ + "c3a1a852c2f266b18cf6ddef68dc93d1.jpg";